import React from 'react';
import style from '../../css/mainCSS/headerInfo.module.css'

function HeaderInfo(props) {
    const mainLink = 'https://bursakopi.com/'
    return (
        <div className={style.container}>
            <div className={style.left_container}>
                <a href={mainLink} target='_blank'>Info menarik lainnya bisa diklik di sini</a>
            </div>
            <div className={style.right_container}>
                <a href={`${mainLink}about`} target='_blank'>Tentang Bursakopi</a>
                <a href={`${mainLink}login`} target='_blank'>Membership</a>
                <a href={`${mainLink}knowledge`} target='_blank'>Knowledge</a>
                <a href={`${mainLink}news`} target='_blank'>News</a>
            </div>
        </div>
    );
}

export default HeaderInfo;